import React from 'react';
import Header from './Components/Header/Header';
import Benefits from './Components/Benefits/Benefits';
import Testimonials from './Components/Testimonials/Testimonials';
import Features from './Components/Features/Features';
import AboutDavid from './Components/AboutDavid/AboutDavid';
import FAQ from './Components/FAQ/FAQ';
import Footer from './Components/Footer/Footer';
import {HeaderLegal} from './Components/HeaderLegal/HeaderLegal';

import './App.css';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Rutas generales con Header */}
          <Route path="/" element={<><Header /><Benefits /><Features /><Testimonials /><AboutDavid /><FAQ /></>} />

          {/* Rutas legales donde se usa HeaderLegal */}
          <Route path="/terms" element={<><HeaderLegal /><Terms /></>} />
          <Route path="/privacy" element={<><HeaderLegal /><Privacy /></>} />
          <Route path="/cookies" element={<><HeaderLegal /><Cookies /></>} />
        </Routes>
        
        {/* Footer común para todas las páginas */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
